import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import CostCenterService from "./CostCenterServices";
import { toast } from "react-toastify";
import { successAlert, successAlertOff } from "../../Global/GlobalSlice";

//GLOBAL THUNK
export const GetGlobalData = createAsyncThunk(
  "cost_center/get_global_data",
  async (arg, { rejectWithValue, getState, dispatch }) => {
    try {
      const returnResponseData = async () => {
        let Branches = getState().costCenter.GlobalData.Branches;
        let Departments = getState().costCenter.GlobalData.Departments;
        let fmtDept = [];
        let Cadres = getState().costCenter.GlobalData.Cadres;
        if (arg.subGroup === "general") {
          let Containers = await CostCenterService.getAllContainers();
          Branches = Containers.filter((c) => c.typeOfContainer === 2);
          Departments = Containers?.map((i) => i.department);
          Departments.forEach((d) => {
            let existingDept = fmtDept.find((fd) => fd.id === d.id);
            if (!existingDept) {
              fmtDept.push(d);
            }
          });

          Cadres = await CostCenterService.getAllCadres();
        }

        let Employees =
          arg.subGroup === "employees" &&
          (await CostCenterService.getAllEmployees(arg.val || ""));

        let Banks = await CostCenterService.FetchChartOfAccounts();
        return {
          Branches,
          Departments: fmtDept,
          Employees,
          Cadres,
          Banks,
        };
      };

      const responseData = returnResponseData();

      return responseData;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Cost Class Thunks
export const CreateCostClass = createAsyncThunk(
  "cost_center/createNewClass",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService.createClass(data);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.data) {
        return responseData?.data;
      } else {
        toast(responseData?.statusMessage);
        return { success: false };
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const GetCostClasses = createAsyncThunk(
  "cost_center/getAllClasses",
  async (
    query = { pageSize: 10, pageNumber: 1, search: "", status: 0 },
    { rejectWithValue, getState, dispatch }
  ) => {
    try {
      const responseObject = await CostCenterService.getAllClasses(query);
      return responseObject;
    } catch (error) {
      console.log({ err: error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const UpdateCostClass = createAsyncThunk(
  "cost_center/update_cost_class",
  async (formData, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService.updateClass(formData);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
        return responseData?.data;
      }
    } catch (error) {
      console.log({ err: error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const DisableCostClass = createAsyncThunk(
  "cost_center/disable_cost_class",
  async (formData, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService.disableClass(formData);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
        return responseData?.data;
      }
    } catch (error) {
      console.log({ err: error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const ApproveDeclineCostClasses = createAsyncThunk(
  "cost_center/approve_decline_cost_classes",
  async (formData, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService.approveDeclineClass(
        formData
      );
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      } else if (responseData?.statusMessage) {
        toast(responseData?.statusMessage);
        return responseData?.data;
      }
    } catch (error) {
      console.log({ err: error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// Cost Services Thunks
export const CreateCostService = createAsyncThunk(
  "cost_center/createNewRecord",
  async (formData, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService.createCostService(formData);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: `You have successfully set up the cost center service. 
              \nYou can now effectively manage and track the financial activity
              and expenditures within your organization.`,
          })
        );
      }
      return responseData?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const GetCostServices = createAsyncThunk(
  "cost_center/getAllRecords",
  async (query, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService.getCostServices(query);

      // if (responseData?.successful === true) {
      //   dispatch(
      //     successAlert({
      //       message: responseData?.data?.statusMessage,
      //     })
      //   );
      // }
      return responseData?.responseObject;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return [] || rejectWithValue(error?.response);
    }
  }
);
export const GetCostService = createAsyncThunk(
  "cost_center/getRecord",
  async (id, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService.getCostService(id);

      return responseData;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const UpdateCostService = createAsyncThunk(
  "cost_center/updateRecord",
  async (formData, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService.updateCostService(formData);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: `You have successfully updated the cost center service. 
              \n Continue to effectively manage and track the financial activity
              and expenditures within your organization.`,
          })
        );
      }
      return responseData?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const ApproveDeclineCostService = createAsyncThunk(
  "cost_center/approveDeclineRecord",
  async (formData, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService.approveDeclineCostService(
        formData
      );
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData.statusMessage,
          })
        );
      }
      return responseData?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const DeleteCostService = createAsyncThunk(
  "cost_center/disableRecord",
  async (id, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService.deleteCostService(id);
      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
      }
      return responseData?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetCostExpenses = createAsyncThunk(
  "cost_center/getAllExpenses",
  async (query, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await CostCenterService?.getCostExpenses(query);

      // if (responseData?.successful === true) {
      //   dispatch(
      //     successAlert({
      //       message: responseData?.data?.statusMessage,
      //     })
      //   );
      // }
      return responseData.responseObject;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return [] || rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  CostCenterService: {},
  SelectedService: {},
  CostCenterExpenses: {},
  SelectedExpense: {},
  CostCenterClass: {},
  SelectedClass: {},
  GlobalData: {},
  editMode: false,
  isLoading: false,
  error: null,
};

const reducers = {
  viewCostClass(state, action) {
    return { ...state, SelectedClass: action.payload };
  },
  viewCostService(state, action) {
    return { ...state, SelectedService: action.payload };
  },
  viewCostExpense(state, action) {
    return { ...state, SelectedExpense: action.payload };
  },
  setEditMode(state, action) {
    return { ...state, editMode: action.payload };
  },
  setEditData(state, action) {
    return { ...state, editData: action.payload };
  },
};

export const RequestSlice = createSlice({
  name: "cost_center",
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(GetCostClasses.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetCostClasses.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          CostCenterClass: action.payload,
        };
      })
      .addCase(GetCostClasses.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });
    builder
      .addCase(CreateCostClass.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(CreateCostClass.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(CreateCostClass.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });
    builder
      .addCase(GetCostServices.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetCostServices.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          CostCenterServices: action.payload,
        };
      })
      .addCase(GetCostServices.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });
    builder
      .addCase(GetCostService.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetCostService.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          CostCenterService: action.payload,
        };
      })
      .addCase(GetCostService.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });
    builder
      .addCase(CreateCostService.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(CreateCostService.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(CreateCostService.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });
    builder
      .addCase(UpdateCostService.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(UpdateCostService.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(UpdateCostService.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });
    builder
      .addCase(DeleteCostService.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(DeleteCostService.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(DeleteCostService.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });
    builder
      .addCase(GetCostExpenses.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetCostExpenses.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          CostCenterExpenses: action.payload,
        };
      })
      .addCase(GetCostExpenses.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });
    builder.addCase(GetGlobalData.fulfilled, (state, action) => ({
      ...state,
      GlobalData: action.payload,
    }));
  },
});

export const {
  setEditMode,
  setEditData,
  viewCostClass,
  viewCostService,
  viewCostExpense,
} = RequestSlice.actions;

export default RequestSlice.reducer;
